// Tela 6 — card de Postura Comportamental. Conversão verbatim de
// design-references/brief-3/shared/cards-3.jsx L1220-1234: markup/classes
// idênticos (beh-card beh-card--{sev}, beh-card__head/__sev/__pattern/__meta).
// window.X → import; F.* → props VM.
import { severityLabel } from '../../labels';

import type { BehavioralPatternCardVM } from '../../view-models';
import type React from 'react';

export function BehavioralPatternCard({
  pattern,
}: {
  pattern: BehavioralPatternCardVM;
}): React.JSX.Element {
  const sev = pattern.severity;
  return (
    <div className={'beh-card beh-card--' + sev}>
      <div className="beh-card__head">
        <b>{pattern.name}</b>
        <span className={`beh-card__sev beh-card__sev--${sev}`}>{severityLabel(sev)}</span>
      </div>
      <div className="beh-card__pattern">&quot;{pattern.pattern}&quot;</div>
      <div className="beh-card__meta tweaks-hint">
        Tendência:{' '}
        {pattern.trend === 'up'
          ? '↗ crescente'
          : pattern.trend === 'down'
            ? '↘ decrescente'
            : '→ estável'}{' '}
        · {pattern.weeks} semana{pattern.weeks === 1 ? '' : 's'}
      </div>
    </div>
  );
}
